import { Select, SelectProps } from 'antd'
import React from 'react'
import { useFacebookLeadgenForms } from '../hooks'

export type LeadgenFormSelectProps = {
    accountId?: string | null
} & SelectProps

export function LeadgenFormSelect({ accountId, ...props }: LeadgenFormSelectProps) {
    const leadgenFormsQuery = useFacebookLeadgenForms(accountId)

    return (
        <Select
            showSearch
            optionFilterProp="label"
            loading={leadgenFormsQuery.isPending}
            options={leadgenFormsQuery.data?.map(({ id, name }) => ({ value: id, label: name }))}
            {...props}
        />
    )
}
